var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 36C3.4 36 2.45833 35.6083 1.675 34.825C0.891667 34.0417 0.5 33.1 0.5 32V4C0.5 2.9 0.891667 1.95833 1.675 1.175C2.45833 0.391667 3.4 0 4.5 0H32.5C33.6 0 34.5417 0.391667 35.325 1.175C36.1083 1.95833 36.5 2.9 36.5 4V32C36.5 33.1 36.1083 34.0417 35.325 34.825C34.5417 35.6083 33.6 36 32.5 36H4.5ZM4.5 10.65H32.5V4H4.5V10.65ZM4.5 21.35H32.5V14.65H4.5V21.35ZM4.5 32H32.5V25.35H4.5V32ZM6.5 9.3V5.3H10.5V9.3H6.5ZM6.5 20V16H10.5V20H6.5ZM6.5 30.7V26.7H10.5V30.7H6.5Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataTable);
export default __webpack_public_path__ + "static/media/data_table.68a9446bc34fcab773f9678d87df79e0.svg";
export { ForwardRef as ReactComponent };